/* eslint-disable @typescript-eslint/no-empty-function */
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { BaseFormFieldComponent } from '../base-form-field.component';

@Component({
  standalone: false,
  selector: 'ideapa-numeric-field',
  template: `
    <ideapa-form-field-wrapper
      [label]="label"
      [tooltip]="tooltip"
      [shouldShowError]="shouldShowError"
      [errors]="errors"
    >
      <!-- tolto prefisso € + allineamento dx -->
      <ideapa-numeric-input
        [hasError]="shouldShowError"
        [formControl]="formControl"
        (blur)="onBlur()"
        [digits]="digits"
        [min]="min"
        [max]="max"
        [digitsOptional]="isCurrency ? false : true"
        [nullable]="isCurrency ? false : nullable"
        [showGroupSeparator]="showGroupSeparator"
        [readOnly]="readOnly"
        [rightAlign]="rightAlign"
        [enforceDigitsOnBlur]="enforceDigitsOnBlur"
        [setFocusOnInit]="setFocusOnInit"
      >
      </ideapa-numeric-input>
      <!-- <ideapa-numeric-input
        [hasError]="shouldShowError"
        [formControl]="formControl"
        (blur)="onBlur()"
        [digits]="digits"
        [min]="min"
        [max]="max"
        [prefix]="isCurrency ? '€ ' : ''"
        [digitsOptional]="isCurrency ? false : true"
        [nullable]="isCurrency ? false : nullable"
        [showGroupSeparator]="showGroupSeparator"
        [readOnly]="readOnly"
      >
      </ideapa-numeric-input> -->
    </ideapa-form-field-wrapper>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NumericFieldComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NumericFieldComponent extends BaseFormFieldComponent {
  @Input()
  digits: number | '*' = 2;

  @Input()
  enforceDigitsOnBlur = false;

  @Input()
  min?: number;

  @Input()
  max?: number;

  @Input()
  isCurrency = false;

  @Input()
  nullable = false;

  @Input()
  rightAlign = true;

  @Input()
  setFocusOnInit = false;

  _value: any = undefined;
  @Input()
  public set value(v: any) {
    this._value = v;
    this.formControl.setValue(v, { emitEvent: false });
  }

  @Input()
  showGroupSeparator = true;

  @Output()
  changed = new EventEmitter<any>();

  @Output()
  // eslint-disable-next-line @angular-eslint/no-output-native
  blur = new EventEmitter();

  onBlur() {
    this.blur.emit(this.formControl.value);
  }
  override onChanged(v: any) {
    super.onChanged(v);
    this.changed.emit(v);
  }
}
